




















import { Component, Vue, Emit } from 'vue-property-decorator';
import { vxm } from '@/store';
import { DefaultBranchName } from '@/@types/theoryGit/branches';

@Component
export default class BranchSelectBox extends Vue {
  private selectedBranchName: string = DefaultBranchName.main;

  private get branchNames() {
    const branches = vxm.theoryGit.branchesStore.getBranches?.results ?? [];
    return branches.map((branch) => {
      return branch.branchName;
    });
  }

  @Emit('changeBranch')
  private onChangeBranch() {
    return this.selectedBranchName;
  }
}
